import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { Modal } from '../Modal';
import { useDialogState } from '../Dialog/useDialogState';

const Tooltip = ({ name }) => {
  const [content, setContent] = useState('');
  const dialogState = useDialogState();
  const { modalTriggerRef, openModal } = dialogState;

  const formattedName = name.trim().toLowerCase();

  useEffect(() => {
    const tooltipContentBlock = document.querySelector(`[data-tooltip-name='${formattedName}']`);

    setContent(tooltipContentBlock?.innerHTML);
  }, [formattedName]);

  if (!content) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="cmp-tooltip"
        onClick={openModal}
        ref={modalTriggerRef}
      >
        ?
      </button>
      <Modal
        title={name}
        id={`tooltip--${formattedName.split(' ').join('-')}`}
        dialogState={dialogState}
      >
        <div
          className="modal__description"
          // tooltips are formatted as HTML in Drupal
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Modal>
    </>
  );
};

Tooltip.propTypes = {
  name: propTypes.string.isRequired,
};

export { Tooltip };
